export type NavLink = {
  label: string
  href: string
}

export type NavGroup = {
  /** Short label used in the desktop nav bar so the row fits on one line. */
  label: string
  /** Full customer-facing category name used in headings and mobile drawer. */
  fullLabel: string
  href: string
  items: NavLink[]
}

/**
 * Customer-facing product navigation — the single source of truth for the
 * restructured catalog tree used by the header nav and the mobile drawer.
 * Internal-only buckets (e.g. Review / Unassigned) never appear here.
 */
export const PRODUCT_NAV: NavGroup[] = [
  {
    label: 'Mailboxes',
    fullLabel: 'Mailboxes',
    href: '/6m8/mailboxes.html',
    items: [
      { label: 'Curbside Mailboxes', href: '/6m8/curbside-mailboxes.html' },
      {
        label: 'Complete Mailbox & Post Systems',
        href: '/6m8/mailboxes/complete-mailbox-post-system.html',
      },
      {
        label: 'Multi Mount Mailbox Systems',
        href: '/6m8/mailboxes/multi-mount-mailbox-systems.html',
      },
      {
        label: 'Wall Mount Mailboxes',
        href: '/6m8/mailboxes/wall-mount-mailboxes.html',
      },
      { label: 'Mailbox Posts', href: '/6m8/mailbox-posts.html' },
      {
        label: 'Locking Mailboxes',
        href: '/6m8/mailboxes/locking-mailboxes.html',
      },
      {
        label: 'Stone & Brick Column Mailboxes',
        href: '/6m8/mailboxes/stone-brick-column-mailboxes.html',
      },
      {
        label: 'Mailbox Parts & Accessories',
        href: '/6m8/mailboxes/mailbox-replacement-parts-and-accessories.html',
      },
    ],
  },
  {
    label: 'Commercial',
    fullLabel: 'Commercial Mailboxes & Parcel Lockers',
    href: '/6m8/commercial-mailboxes-lockers.html',
    items: [
      {
        label: 'Cluster Mailboxes, CBUs & 4C Mailboxes',
        href: '/6m8/commercial-mailboxes-lockers/centralized-delivery-mailboxes-and-kiosks.html',
      },
      {
        label: 'Parcel Lockers',
        href: '/6m8/commercial-mailboxes-lockers/parcel-lockers.html',
      },
      {
        label: 'Collection Boxes',
        href: '/6m8/commercial-mailboxes-lockers/collection-boxes.html',
      },
      {
        label: 'Key Keepers & Key Blanks',
        href: '/6m8/commercial-mailboxes-lockers/key-keepers-key-blanks.html',
      },
      {
        label: 'Mail Slots, Letter & Book Drops',
        href: '/6m8/commercial-mailboxes-lockers/mail-slots-letter-book-drops.html',
      },
      {
        label: 'Commercial Replacement Parts',
        href: '/6m8/commercial-mailboxes-lockers/replacement-commercial-locks-hinges-doors.html',
      },
    ],
  },
  {
    label: 'Street Signs & Traffic Signs',
    fullLabel: 'Street Signs & Traffic Signs',
    href: '/6m8/street-signs-traffic-signs.html',
    items: [
      {
        label: 'Traffic Signs',
        href: '/6m8/street-signs-traffic-signs/traffic-road-signs.html',
      },
      {
        label: 'Sign Frames & Back Plates',
        href: '/6m8/street-signs-traffic-signs/sign-frames-back-plates.html',
      },
    ],
  },
  {
    label: 'Decorative Signage',
    fullLabel: 'Decorative Signage',
    href: '/6m8/decorative-signage.html',
    items: [
      { label: 'Decorative Signage', href: '/6m8/decorative-signage.html' },
      {
        label: 'Sign Frames, Bases & Hardware',
        href: '/6m8/decorative-signage/replacement-bases-finials-sign-mounts.html',
      },
      { label: 'Message Boards', href: '/6m8/message-boards.html' },
    ],
  },
  {
    label: 'Outdoor Accessories',
    fullLabel: 'Outdoor Accessories & Home Accents',
    href: '/6m8/outdoor-accessories-home-accents.html',
    items: [
      {
        label: 'Address Plaques & House Numbers',
        href: '/6m8/address-plaques-and-house-numbers.html',
      },
      {
        label: 'Illuminated Address Plaques',
        href: '/6m8/address-plaques-and-house-numbers/illuminated-address-plaques.html',
      },
      {
        label: 'Planters & Window Boxes',
        href: '/6m8/outdoor-accessories-home-accents/planters-window-boxes.html',
      },
      {
        label: 'Home Exterior Accents',
        href: '/6m8/outdoor-accessories-home-accents/home-exterior-accents.html',
      },
      {
        label: 'Garden Decor',
        href: '/6m8/outdoor-accessories-home-accents/garden-decor.html',
      },
      {
        label: 'Country Bells',
        href: '/6m8/outdoor-accessories-home-accents/country-bells.html',
      },
      {
        label: 'Patio Coolers',
        href: '/6m8/outdoor-accessories-home-accents/patio-coolers.html',
      },
      {
        label: 'Door Chimes & Doorbells',
        href: '/6m8/mailboxes/door-chimes-doorbells.html',
      },
    ],
  },
  {
    label: 'Lighting',
    fullLabel: 'Outdoor Lighting',
    href: '/6m8/lighting.html',
    items: [
      {
        label: 'Outdoor Lamp Posts',
        href: '/6m8/lighting/outdoor-lamp-posts.html',
      },
      {
        label: 'Post Lights & Fixtures',
        href: '/6m8/lighting/post-lights-fixtures.html',
      },
      {
        label: 'Commercial Lighting',
        href: '/6m8/lighting/commercial-lighting.html',
      },
      { label: 'Light Blocks', href: '/6m8/lighting/light-blocks.html' },
    ],
  },
]
